import type { CSSProperties, InputHTMLAttributes, TextareaHTMLAttributes } from "react";
import { C, font } from "../theme";

/** Input com o visual padrão do Apogeu. */
export function FieldInput({ style, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className="apogeu-field"
      style={{
        fontFamily: font,
        width: "100%",
        boxSizing: "border-box",
        fontSize: 13,
        color: C.ink,
        border: `1px solid ${C.faint}`,
        borderRadius: 10,
        padding: 10,
        ...style,
      }}
      {...rest}
    />
  );
}

/** Textarea com o visual padrão do Apogeu. */
export function FieldTextarea({ style, ...rest }: TextareaHTMLAttributes<HTMLTextAreaElement>) {
  return (
    <textarea
      style={{
        fontFamily: font,
        width: "100%",
        boxSizing: "border-box",
        minHeight: 64,
        fontSize: 13,
        color: C.gray,
        border: `1px solid ${C.faint}`,
        borderRadius: 10,
        padding: 10,
        resize: "vertical",
        ...style,
      }}
      {...rest}
    />
  );
}
